import React from 'react';

import { ABORTIVE_VISIT_CHARGE_LABEL, ABORTIVE_VISIT_CHARGE_LINK } from './constants';

export const MissedEngineerVisitAccordion: React.FC = () => (
  <p>
      If you miss an engineer visit or if your site isn’t ready for the engineer, you may need to pay an{' '}
    <a href={ABORTIVE_VISIT_CHARGE_LINK} target="_blank" rel="noreferrer">
      {ABORTIVE_VISIT_CHARGE_LABEL}
    </a>
      . Missing a visit also causes delays. It’s important you change or cancel an engineer visit by 12noon on the day
      before your engineer visit if you won’t be able to make it.
  </p>
);
